var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-row",
    { staticStyle: { padding: "20px" }, attrs: { gutter: 15 } },
    [
      _c(
        "q-col",
        { attrs: { span: 11 } },
        [
          _c("trusted-permissions", {
            attrs: {
              trusted: _vm.currentTrust,
              permissions: _vm.currentTrust.permissions,
            },
            on: { update: _vm.updateTrustedList },
            model: {
              value: _vm.currentTrust.trusteeList,
              callback: function ($$v) {
                _vm.$set(_vm.currentTrust, "trusteeList", $$v)
              },
              expression: "currentTrust.trusteeList",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-col",
        { attrs: { span: 13 } },
        [
          _c(
            "q-input",
            {
              staticClass: "search",
              attrs: {
                placeholder: this.$qt("permission.editor.searchPlaceHolder"),
              },
              model: {
                value: _vm.filterText,
                callback: function ($$v) {
                  _vm.filterText = $$v
                },
                expression: "filterText",
              },
            },
            [
              _c("q-button", {
                attrs: { slot: "append", icon: "q-icon-search" },
                slot: "append",
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("q-tree", {
            ref: "allTrusted",
            staticClass: "filter-tree",
            attrs: {
              data: _vm.trustList,
              props: _vm.defaultProps,
              "default-expand-all": "",
              "filter-node-method": _vm.filterNode,
            },
            on: { "node-click": _vm.handleNodeClick },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }